<template>
  <div>
    <Banner></Banner>
    <ProList></ProList>
    <Case></Case>
    <About></About>
    <News></News>
    <Customer></Customer>
  </div>
</template>

<script>
import Banner from '@/components/index/banner'
import ProList from '@/components/index/proList'
import Case from '@/components/index/case'
import About from '@/components/index/about'
import News from '@/components/index/new'
import Customer from '@/components/index/customer'
export default {
	name: 'index',
	components:{
		Banner,
    ProList,
    Case,
    About,
    News,
    Customer
	},
	data() {
		return {
      
		};
	},
  metaInfo: {
    title: '佛山鼎吉-首页', // set a title
    meta: [{ // set meta
      name: 'keywords',
      content: '鼎吉,鼎吉官网,陶瓷墙地砖拣选包装自动化设备,研发、设计、制造、安装为一体的高新技术型企业,佛山市鼎吉包装技术有限公司'
    },
    { // set meta
      name: 'description',
      content: '佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'
    }],
    link: [{ // set link
      rel: 'asstes',
      href: 'https://www.dinovor.com/'
    }]
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/index/index.vue